import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./styles/HomePage.css";

import homeBackground from "../medias/png/background/home_background.png";
import homeBackgroundMobile from "../medias/png/background/home_background_mobile.png";
import homeCyclistZoom from "../medias/png/background/home_cyclist_zoom.png";
import homeTeam1 from "../medias/png/background/home-team1.png";
import homeTeam2 from "../medias/png/background/home-team2.png";
import homeTeam3 from "../medias/png/background/home-team3.png";
import homeTeam4 from "../medias/png/background/home-team4.png";
import homeTeam5 from "../medias/png/background/home-team5.png";

const HomePage = () => {
  const { t } = useTranslation();
  const [isMobile] = useState(window.innerWidth <= 699);

  const renderMultiline = (text) =>
    String(text)
      .split("\n")
      .map((line, i) => (
        <React.Fragment key={i}>
          {line}
          {i < text.split("\n").length - 1 ? <br /> : null}
        </React.Fragment>
      ));

  return (
    <main className="home">
      <section className="home-section1">
        <div className="home-section1-background">
          <img
            src={isMobile ? homeBackgroundMobile : homeBackground}
            className="home-section1-background-image"
            alt={t("home.hero.imageAlt")}
            loading="lazy"
          />
        </div>
      </section>

      <section className="home-section2">
        <div className="home-section2-left-container">
          <div className="home-section2-text-content">
            <h1>{t("home.hero.title")}</h1>
            <h2>{t("home.hero.subtitle")}</h2>
            <p>{renderMultiline(t("home.hero.description"))}</p>

            <Link to="/signup">
              <button className="home-section2-button">
                {t("home.hero.cta")} {" >"}
              </button>
            </Link>
          </div>
        </div>

        <div className="home-section2-right-container">
          <img
            src={homeCyclistZoom}
            alt={t("home.hero.zoomAlt")}
            className="home-section2-right-image"
            loading="lazy"
          />
        </div>
      </section>

      <section className="home-section3">
        <div className="home-section3-container-create-team">
          <div className="home-section3-left-create-team">
            <img
              src={homeTeam1}
              alt={t("home.sections.createTeam.leftAlt")}
              className="home-section3-left-image-create-team"
            />
          </div>

          <div className="home-section3-content-create-team">
            <h2 className="home-section3-title-create-team">
              {t("home.sections.createTeam.title")}
            </h2>
            <p>{t("home.sections.createTeam.p1")}</p>
            <p>{t("home.sections.createTeam.p2")}</p>
          </div>

          <div className="home-section3-right-create-team">
            <img
              src={homeTeam2}
              alt={t("home.sections.createTeam.rightAlt")}
              className="home-section3-right-image-create-team"
            />
          </div>
        </div>

        <div className="home-section3-container-choose-calendar blue-bg">
          <div className="home-section3-left-choose-calendar">
            <img
              src={homeTeam3}
              alt={t("home.sections.chooseCalendar.leftAlt")}
              className="home-section3-left-image-choose-calendar"
            />
          </div>

          <div className="home-section3-content-choose-calendar">
            <h2 className="home-section3-title-choose-calendar">
              {t("home.sections.chooseCalendar.title")}
            </h2>
            <p>{t("home.sections.chooseCalendar.p1")}</p>
            <p>{t("home.sections.chooseCalendar.p2")}</p>
          </div>
        </div>

        <div className="home-section3-container-collect-badges">
          <div className="home-section3-content-collect-badges">
            <img
              src={homeTeam4}
              alt={t("home.sections.collectBadges.leftAlt")}
              className="home-section3-left-image-collect-badges"
            />

            <div className="home-section3-badge">{t("home.sections.collectBadges.badge")}</div>

            <h2 className="home-section3-title-collect-badges">
              {t("home.sections.collectBadges.title")}
            </h2>

            <p>{t("home.sections.collectBadges.p1")}</p>
            <p>{t("home.sections.collectBadges.p2")}</p>
          </div>

          <div className="home-section3-right-collect-badges">
            <img
              src={homeTeam5}
              alt={t("home.sections.collectBadges.rightAlt")}
              className="home-section3-right-image-collect-badges"
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default HomePage;
